import { isBetaTester } from "./functions";
import type { ConditionFunction, ConditionKeys } from "./types";

export const allConditions: Record<ConditionKeys, ConditionFunction> = {
	IS_BETA_TESTER: isBetaTester,
};
